<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-notebook
      </v-icon> Knowledge Base
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col class="text-right">
        <v-btn
          color="#FF3700"
          @click="openCreateKnowledgeBase()"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              :hint="isSearchAdded ? searchHint : ''"
              append-icon="mdi-magnify"
              outlined
              dense
              @keyup.enter="handleSearch"
              @keydown.esc="clearSearch"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <!-- <v-data-table
        :headers="headers"
        :items="knwbaseList"
        :search="search"
        class="elevation-1"
      > -->
      <v-data-table
        :headers="headers"
        :items="paginatedKbList"
        :search="search"
        class="elevation-1"
        disable-sort
        :items-per-page="itemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30],
        }"
        :server-items-length="totalFilteredRecords"
        :options.sync="options"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.knowledge.title }}</td>
            <td>{{ item.knowledge.category.name }}</td>
            <td>{{ item.knowledge.type }}</td>
            <td>{{ item.knowledge.created_at | convertToLocal }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="showKnowledgeBaseDetails(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2 ml-2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click="deleteKnowledgebase(item.knowledge)"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                v-if="item.knowledge.type === 'draft'"
                color="green"
                dense
                @click.stop
                @click="confirmPublish(item)"
              >
                <v-icon>mdi-earth</v-icon>Publish
              </v-btn><v-btn
                v-else
                color="grey"
                disabled
                dense
                @click.stop
              >
                <v-icon>mdi-check</v-icon>Published
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner :loading="loading" />
    <delete-dialog
      v-if="showDeleteKbModal"
      :title="'Delete Knowledge base?'"
      @closed="showDeleteKbModal = false"
      @confirmed="deleteConfirmed()"
    />
    <delete-dialog
      v-if="showPublish"
      :title="'Publish Knowledge Base'"
      :message="'Are you sure you want to publish ?'"
      :button1="'No'"
      :button2="'Yes'"
      @closed="showPublish = false"
      @confirmed="publishConfirmed()"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';
  import moment from 'moment';
  import Constants from 'src/constants';
  export default {
    name: 'KnowledgeBase',
    components: {
      'centre-spinner': spinner,
      'delete-dialog': DeleteDialog,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data () {
      return {
        headers: [
          { text: 'Title', align: 'start', value: 'title' },
          { text: 'Category', value: 'category' },
          { text: 'Type', value: 'type' },
          { text: 'Added On', value: 'created_at' },
          { text: 'More', value: 'more' },
          { text: 'Delete', value: 'delete' },
          { text: 'Action', value: 'action' },
        ],
        loading: false,
        showPublish: false,
        search: null,
        page: 1,
        itemsPerPage: 10,
        pageStart: 0,
        deletingItem: [],
        showDeleteKbModal: false,
        options: {},
      };
    },
    computed: {
      knwbaseList () {
        return this.$store.getters['knowledgebase/getKnowledgeBase'];
      // const sortedList = list.sort((a, b) => {
      //   return new Date(b.created_at) - new Date(a.created_at);
      // });
      },
      paginatedKbList () {
        var list = this.$store.getters['knowledgebase/getKnowledgeBase'];
        return list.data;
      },
      totalFilteredRecords () {
        if (Object.keys(this.knwbaseList).length > 0) {
          return this.knwbaseList.total;
        }
        return 0;
      },
      searchHint () {
        return `Press Enter to filter by name: '${this.search}' or press ESC to clear.`;
      },
      isSearchAdded () {
        if (this.search === null || this.search === '') {
          return false;
        }
        return true;
      },
    },
    watch: {
      options: {
        async handler () {
          await this.paginatedCall();
        },
        deep: true,
      },
    },
    async mounted () {
      await this.getKnowledgebaseList();
    },
    methods: {
      async paginatedCall () {
        this.itemsPerPage = this.options.itemsPerPage;
        this.pageStart =
          this.options.page * this.itemsPerPage - this.itemsPerPage;
        this.getKnowledgebaseList();
      },
      confirmPublish (item) {
        this.itemForPublish = item;
        this.showPublish = true;
      },
      async publishConfirmed () {
        this.showPublish = false;
        this.loading = true;
        await this.$store
          .dispatch('knowledgebase/PublishKnowledgeBase', {
            knowledgeId: this.itemForPublish.knowledge.id,
          })
          .then((response) => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Knowledgebase Published successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.getKnowledgebaseList();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      deleteKnowledgebase (item) {
        this.deletingItem = item;
        this.showDeleteKbModal = true;
      },
      showKnowledgeBaseDetails (itemid) {
        this.$router.push(`updateknowledgebase/${itemid.knowledge.slug}`);
      },
      async deleteConfirmed () {
        await this.$store.dispatch('knowledgebase/deleteKnowledgebase', {
          id: this.deletingItem.id,
        });
        this.showDeleteKbModal = false;
        this.getKnowledgebaseList();
      },
      async getKnowledgebaseList () {
        this.loading = true;
        await this.$store.dispatch('knowledgebase/fetchKnowledgebase', {
          params: {
            limit: this.itemsPerPage,
            startPage: this.pageStart,
            title: this.search !== '' ? this.search : null,
          },
        });
        this.loading = false;
      },
      async handleSearch () {
        this.options.page = 1;
        this.pageStart = 0;
        await this.getKnowledgebaseList();
      },
      async clearSearch () {
        this.options.page = 1;
        this.pageStart = 0;
        this.search = null;
        await this.getKnowledgebaseList();
      },
      openCreateKnowledgeBase () {
        this.$router.push({ name: 'CreateKnowledgeBase' });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474f;
  margin-left: 20px;
}
.icon-style {
  color: #37474f;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474f !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474f !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #cfd8dc;
}
.font-my-style {
  font-weight: bold;
}
.v-data-table {
  background-color: #eceff1;
}
</style>
